import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useHistory } from "react-router-dom";
import "./Slider.css";
import Button from "@material-ui/core/Button";

export default (props) => {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [sliderRef, slider] = useKeenSlider({
    initial: 0,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });

  let history = useHistory();

  function handleClick() {
    history.push("/ContentExp/");
    window.scrollTo(0, 0);
  }

  return (
    <>
      <div className="navigation-wrapper">
        <div ref={sliderRef} className="keen-slider">
          <div className="keen-slider__slide number-slide1">
            <div className="Slider1Cont">
              <h1 className="SliderTitle">¿Cómo se hacen las velas?</h1>
              <div className="btnCont1">
                <Button
                  className="btnContenido"
                  variant="contained"
                  color="secondary"
                  onClick={handleClick}
                >
                  Leer articulo
                </Button>
              </div>
            </div>
          </div>
          <div className="keen-slider__slide number-slide1"></div>
          <div className="keen-slider__slide number-slide1"></div>
          <div className="keen-slider__slide number-slide1"></div>{" "}
          {slider && (
            <div className="dots">
              {[...Array(slider.details().size).keys()].map((idx) => {
                return (
                  <button
                    key={idx}
                    onClick={() => {
                      slider.moveToSlideRelative(idx);
                    }}
                    className={"dot" + (currentSlide === idx ? " active" : "")}
                  />
                );
              })}
            </div>
          )}
        </div>{" "}
      </div>
    </>
  );
};
